
const data = {
  getWarehouseDataByProvinceCode:(params) => {
    let foundItem;
    const {provinceCode} = params;
    Object.entries(params.warehouseData).find(([key, warehouseData]) => {
      if(provinceCode) {
        if (warehouseData.provinceCode == provinceCode) {
          foundItem = warehouseData;
          return true;
        }

        const {additionalProvinceCodes = []} = warehouseData;

        if (additionalProvinceCodes.length && additionalProvinceCodes.includes(provinceCode)) {
          foundItem = warehouseData;
          return true;
        }
      }
    });
    return foundItem;
  }
};
module.exports = data;
